import React from "react";
import { Download, FileSpreadsheet } from "lucide-react";
import { excelExportUrl } from "../lib/api";

export default function Bericht() {
  const today = new Date().toLocaleDateString("de-DE", {
    day: "2-digit", month: "long", year: "numeric",
  });

  return (
    <div data-testid="bericht-page" className="pb-container px-8 py-8 space-y-6">
      <div>
        <div className="pb-eyebrow">Newton Campus · Datenexport</div>
        <h1 className="font-display font-bold text-navy text-[34px] tracking-[-0.02em] mt-2 leading-none">
          Investoren-Export
        </h1>
        <p className="text-sm text-navy/55 font-sans mt-2 max-w-2xl">
          Komplettexport aller Investoren auf aktuellem Datenstand.
        </p>
      </div>

      <section className="max-w-2xl">
        <div className="pb-card">
          <div className="flex items-start gap-3 mb-4">
            <FileSpreadsheet size={28} className="text-heiss mt-1" strokeWidth={1.5} />
            <div className="flex-1">
              <h2 className="font-display font-bold text-navy text-xl tracking-tight">
                Excel-Komplettexport
              </h2>
              <p className="text-xs text-navy/55 mt-1 uppercase tracking-widish">
                .xlsx · 35 Spalten · Stand {today}
              </p>
            </div>
          </div>
          <ul className="text-sm text-navy/75 space-y-1.5 mb-5 font-sans">
            <li>Alle Investoren mit Stammdaten</li>
            <li>Welle, Einstufung, Investorentyp, Phase</li>
            <li>Quellen, Betreuer, Sperren, NDA-Status</li>
            <li>Datenraum-Freischaltung, AuM, Fokus</li>
            <li>Primärkontakt (Vor-/Nachname, E-Mail, Telefon)</li>
            <li>Sortiert nach Firma A→Z</li>
          </ul>
          <a
            href={excelExportUrl()}
            download
            data-testid="bericht-excel-download"
            className="pb-btn-outline text-xs uppercase tracking-widish font-semibold"
          >
            <Download size={13} /> Excel herunterladen
          </a>
        </div>
      </section>
    </div>
  );
}
